import React, { createRef } from "react";
import { dialog, printComponent } from "../../../nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";
import InterviewFormPagePresenter from "./InterviewFormPagePresenter";
import InterviewForm from "../../../components/InterviewForm";
import InterviewFormPDF from "../components/InterviewFormPDF";
import { auditUseCase } from "../../../usecases/audit";
import { exportToZip } from "../../../pdfZipExporter";

class InterviewOnlineFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      selected: [],
      progress: true,
      count: 0,
      where: {},
      appearanceRating: "",
      bearingRating: "",
      expressionRating: "",
      jobKnowledgeRating: "",
      motivationRating: "",
      personalityRating: "",
      isRecruiter: false,
    };
    this.presenter = new InterviewFormPagePresenter(
      this,
      upsertUseCase(),
      getObjectUseCase(),
      findObjectUseCase(),
      deleteObjectUseCase(),
      auditUseCase()
    );

    this.interviewFormPDF = createRef();
  }

  async componentDidMount() {
    await this.presenter.init();
    await this.presenter.getObject();

    const user = await this.getCurrentUser();
    const isRecruiter = await user.roles.some(
      (role) => role.id === "Recruiter"
    );
    // const totalPoints = await this.calculateTotalPoints();

    this.setState({ isRecruiter: isRecruiter });
  }

  getCollectionName() {
    return "online_applicants";
  }

  handleCheckboxChange = (category, value) => {
    this.setState({ [category]: value });
  };

  calculateTotalPoints = () => {
    const {
      appearanceRating,
      bearingRating,
      expressionRating,
      jobKnowledgeRating,
      motivationRating,
      personalityRating,
    } = this.state;

    return (
      Number(appearanceRating) +
      Number(bearingRating) +
      Number(expressionRating) +
      Number(jobKnowledgeRating) +
      Number(motivationRating) +
      Number(personalityRating)
    );
  };

  saveObject(formState, object, totalPoints) {
    this.presenter.handleSubmit(formState, object, totalPoints);
  }

  goBack() {
    const history = window.history;
    history.back();
  }
  onCancel() {
    const history = window.history;

    sessionStorage.removeItem("interviewDatasOnline");
    history.back();
  }

  exportPDF() {
    printComponent(this.interviewFormPDF.current);
  }

  render() {
    const { object, isRecruiter, progress, selected } = this.state;
    const user = this.getCurrentUser();

    console.warn("selected", selected);
    return (
      <>
        <div className="d-none">
          <div ref={this.interviewFormPDF}>
            <InterviewFormPDF object={object} />
          </div>
        </div>
        <NavBar user={user} />
        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <h1 className="fw-bold mt-3 fs-4">
              <div className="d-flex gap-3 mb-3 align-items-center">
                <div
                  className="rounded-5 p-1 cursor-pointer"
                  style={{ backgroundColor: `#E6E6E6` }}
                  onClick={this.goBack.bind(this)}
                >
                  <i
                    class="bi bi-arrow-left-short"
                    style={{ width: `1rem`, height: `1rem` }}
                  ></i>
                </div>
                <span style={{ color: `#D1823780` }}>Application Form</span>
                <span>
                  <i class="bi bi-chevron-right fs-5"></i>
                </span>
                <span style={{ color: `#D18237` }}>Interview Form</span>
              </div>
            </h1>
            {object?.interviewForm && (
              <div className="d-flex justify-content-end mb-2">
                <button
                  className="btn text-white fw-bold"
                  style={{ backgroundColor: "#3174ad" }}
                  onClick={this.exportPDF.bind(this)}
                >
                  <i class="bi bi-file-earmark-text me-2 fw-bold"></i>
                  Export Interview Form
                </button>
              </div>
            )}

            <InterviewForm
              onSave={this.saveObject.bind(this)}
              object={object}
              onCancel={this.onCancel.bind(this)}
              isRecruiter={isRecruiter}
              progress={progress}
            />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InterviewOnlineFormPage);
